var _path, _polygon, _path2, _path3, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-22",
    d: "M104.74,442c80.57,42.47,211.2,42.47,291.77,0s80.58-111.31,0-153.77-211.2-42.47-291.78,0S24.16,399.51,104.74,442Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-22",
    d: "M70.19,388.85,73.93,391a4.79,4.79,0,0,0,4.33,0l172.82-99.77a1.31,1.31,0,0,0,0-2.49l-3.71-2.12a4.79,4.79,0,0,0-4.33,0L70.19,386.35A1.32,1.32,0,0,0,70.19,388.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-22",
    cx: 319.68,
    cy: 395.88,
    rx: 52.74,
    ry: 28.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-22",
    cx: 380.61,
    cy: 323.81,
    rx: 40.69,
    ry: 22.31,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.51,301.39c-.06-5.11,3.51-15.73,8.73-22.43s13.49-11.65,19.44-9.69c5.54,1.82,5,9.06-1.61,13.93s-16.61,11-19.46,19.34l-6.05,10.24Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.51,301.39c-.06-5.11,3.51-15.73,8.73-22.43s13.49-11.65,19.44-9.69c5.54,1.82,5,9.06-1.61,13.93s-16.61,11-19.46,19.34l-6.05,10.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.22,308.39a.38.38,0,0,0,.33-.31c3.21-17.48,17.15-31.82,25.55-35.05a.38.38,0,0,0,.22-.49.37.37,0,0,0-.48-.21c-8.57,3.29-22.77,17.87-26,35.62a.37.37,0,0,0,.3.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,319.52c.79-2.88,4.24-7.66,9.86-11.65,6.23-4.4,14.15-6.49,15.94-9.88,2.15-4.08-1.31-7.86-7.75-7s-17.66,9.81-19.32,23.07Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.67,316.52a.38.38,0,0,0,.32-.25c5.16-15,16.5-20.38,21.77-21.13a.38.38,0,0,0,.32-.42.37.37,0,0,0-.42-.32c-5.83.83-17.1,6.31-22.38,21.63a.37.37,0,0,0,.23.47A.3.3,0,0,0,401.67,316.52Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.85,386.33l-.76-.44a4.86,4.86,0,0,1-2.2-3.8V125.83a4.89,4.89,0,0,1,2.2-3.81L239.21,26.7a4.87,4.87,0,0,1,4.4,0l.75.44a4.85,4.85,0,0,1,2.2,3.81V287.2a4.85,4.85,0,0,1-2.2,3.81L79.25,386.33A4.87,4.87,0,0,1,74.85,386.33Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,30.6c-.15-1.14-1.07-1.56-2.17-.93L79.24,125a4.54,4.54,0,0,0-1.55,1.64l-5.15-3A4.6,4.6,0,0,1,74.1,122L239.21,26.7a4.87,4.87,0,0,1,4.4,0l.76.44A5,5,0,0,1,246.54,30.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,386.5a4.89,4.89,0,0,1-4-.17l-.77-.44a4.85,4.85,0,0,1-2.19-3.81V125.83a4.42,4.42,0,0,1,.64-2.16l5.15,3A4.61,4.61,0,0,0,77,128.8V385.06C77,386.32,77.84,386.91,78.88,386.5Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tabs--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.52,293.65l-.76-.44a4.86,4.86,0,0,1-2.2-3.8V243.35a4.88,4.88,0,0,1,2.2-3.81l149.91-86.63a4.85,4.85,0,0,1,4.39,0l.76.44a4.85,4.85,0,0,1,2.2,3.81v46.06a4.83,4.83,0,0,1-2.2,3.8l-149.9,86.63A4.87,4.87,0,0,1,96.52,293.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,156.81c-.15-1.14-1.07-1.56-2.18-.93L100.91,242.52a4.54,4.54,0,0,0-1.55,1.64l-5.15-3a4.51,4.51,0,0,1,1.56-1.65l149.9-86.63a4.85,4.85,0,0,1,4.39,0l.76.44A4.93,4.93,0,0,1,253,156.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,293.83a4.87,4.87,0,0,1-4-.18l-.78-.43a4.9,4.9,0,0,1-2.18-3.81V243.35a4.42,4.42,0,0,1,.64-2.16l5.15,3a4.61,4.61,0,0,0-.65,2.16v46.07C98.71,293.64,99.51,294.23,100.54,293.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,239.43c8.55-4.94,15.48-1.1,15.48,8.58s-6.94,21.44-15.5,26.27-15.49,1-15.49-8.58S113.56,244.37,122.11,239.43Z",
    style: {
      fill: "#5DAC32"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.52,356.07l-.76-.44a4.86,4.86,0,0,1-2.2-3.8V305.77a4.88,4.88,0,0,1,2.2-3.81l149.91-86.63a4.85,4.85,0,0,1,4.39,0l.76.44a4.84,4.84,0,0,1,2.2,3.81v46.06a4.83,4.83,0,0,1-2.2,3.8l-149.9,86.63A4.87,4.87,0,0,1,96.52,356.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,219.22c-.15-1.14-1.07-1.55-2.18-.92L100.91,304.94a4.59,4.59,0,0,0-1.55,1.63l-5.15-3A4.44,4.44,0,0,1,95.77,302l149.9-86.63a4.85,4.85,0,0,1,4.39,0l.76.44A4.91,4.91,0,0,1,253,219.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,356.24a4.87,4.87,0,0,1-4-.17l-.78-.44a4.87,4.87,0,0,1-2.18-3.81V305.77a4.39,4.39,0,0,1,.64-2.16l5.15,3a4.68,4.68,0,0,0-.65,2.17v46.07C98.71,356.06,99.51,356.65,100.54,356.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,301.85c8.55-4.94,15.48-1.1,15.48,8.58s-6.94,21.44-15.5,26.27-15.49,1-15.49-8.58S113.56,306.78,122.11,301.85Z",
    style: {
      fill: "#5DAC32"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.52,189.27l-.76-.44a4.88,4.88,0,0,1-2.2-3.81V139a4.86,4.86,0,0,1,2.2-3.8L245.67,48.53a4.85,4.85,0,0,1,4.39,0l.76.44a4.83,4.83,0,0,1,2.2,3.8V98.83a4.85,4.85,0,0,1-2.2,3.81l-149.9,86.63A4.87,4.87,0,0,1,96.52,189.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,52.42c-.15-1.14-1.07-1.55-2.18-.92L100.91,138.14a4.43,4.43,0,0,0-1.55,1.63l-5.15-3a4.41,4.41,0,0,1,1.56-1.64l149.9-86.63a4.85,4.85,0,0,1,4.39,0l.76.44A4.91,4.91,0,0,1,253,52.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,189.44a4.87,4.87,0,0,1-4-.17l-.78-.44A4.87,4.87,0,0,1,93.57,185V139a4.42,4.42,0,0,1,.64-2.17l5.15,3a4.64,4.64,0,0,0-.65,2.17V188C98.71,189.26,99.51,189.84,100.54,189.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,135.05c8.55-4.94,15.48-1.1,15.48,8.57s-6.94,21.44-15.5,26.28-15.49,1-15.49-8.58S113.56,140,122.11,135.05Z",
    style: {
      fill: "#5DAC32"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.06,247.75l-.76-.44a4.85,4.85,0,0,1-2.2-3.81V197.44a4.87,4.87,0,0,1,2.2-3.81L256.2,107a4.87,4.87,0,0,1,4.4,0l.76.43a4.89,4.89,0,0,1,2.2,3.81v46.06a4.88,4.88,0,0,1-2.2,3.81L111.45,247.75A4.85,4.85,0,0,1,107.06,247.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54,110.9c-.15-1.14-1.07-1.56-2.18-.92L111.45,196.62a4.54,4.54,0,0,0-1.56,1.63l-5.14-3a4.49,4.49,0,0,1,1.55-1.65L256.2,107a4.87,4.87,0,0,1,4.4,0l.76.43A4.93,4.93,0,0,1,263.54,110.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.08,247.92a4.89,4.89,0,0,1-4-.17l-.77-.44a4.87,4.87,0,0,1-2.19-3.81V197.44a4.43,4.43,0,0,1,.65-2.16l5.14,3a4.59,4.59,0,0,0-.64,2.16v46.07C109.25,247.73,110,248.32,111.08,247.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.65,193.52c8.55-4.93,15.48-1.09,15.48,8.58s-6.94,21.44-15.5,26.28-15.5,1-15.49-8.58S124.1,198.46,132.65,193.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,221.35a1.68,1.68,0,0,1-1.9.09l-6.8-5.14c-.91-.69-.8-2.58.25-4.24s2.64-2.44,3.54-1.75l4.74,3.59L146,185.61c.82-1.77,2.39-3,3.51-2.65s1.36,2,.53,3.74L135,219a5.43,5.43,0,0,1-1.93,2.29Z",
    style: {
      fill: "#5DAC32"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.52,179.3l-4.35-2.51h0c-1.89-1.08-4.2,0-5.42.74L251,176h0c-3.29-2-7.87,2.17-8.89,3.16l-1.18-.67h0c-3.49-2.1-9.84,3.53-9.84,3.53V161l2.76-1.33-4.39-2.54h0l0,0h0a3.93,3.93,0,0,0-3.9.41h0a12.32,12.32,0,0,0-5.58,9.66v48.57c-4-3-8.28-4.8-12-4.13a12.08,12.08,0,0,0-7.26,5c-1.84,3.26,1.2,5.3,5.12,9.78s7.32,9.8,10.86,13.1a19.15,19.15,0,0,0,6.11,4.16V250l4.3,2.49,28.48-21.41v-6.33s4.06-16.22,5.36-23c1.25-6.52,2.4-16.93.25-22.33l2.33-.16Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,179.3l-4.35-2.51h0c-1.89-1.08-4.2,0-5.42.74L251,176h0c-3.29-2-7.87,2.17-8.89,3.16l-1.18-.67h0c-3.49-2.1-9.84,3.53-9.84,3.53V161l2.76-1.33-4.39-2.54h0l0,0h0a3.93,3.93,0,0,0-3.9.41h0a12.32,12.32,0,0,0-5.58,9.66v48.57c-4-3-8.28-4.8-12-4.13a12.08,12.08,0,0,0-7.26,5c-1.84,3.26,1.2,5.3,5.12,9.78s7.32,9.8,10.86,13.1a19.15,19.15,0,0,0,6.11,4.16V250l4.3,2.49,28.48-21.41v-6.33s4.06-16.22,5.36-23c1.25-6.52,2.4-16.93.25-22.33l2.33-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.41,235.12l-21.54-12.43-9.43-5.45c-1.2,2.94,1.71,5,5.39,9.21,3.89,4.45,7.32,9.8,10.86,13.1a19.15,19.15,0,0,0,6.11,4.16V250l4.3,2.49,6.29-4.73C232.58,242.42,231.41,235.12,231.41,235.12Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.29 169.71 219.99 167.22 219.99 218.17 224.29 218.28 224.29 169.71",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,182.57l3.34-2.46c-.08-.22-.14-.44-.23-.65l1.22-.08-2.68-.12-4.47-2.47a10.61,10.61,0,0,0-1.51.75l1.4.81Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25,181.84l3.13-2.38-4.32-2.62a19,19,0,0,0-2.91,2.3l3,1.74Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.71 181.61 235.43 179.11 235.45 179.07 235.45 184.48 240.43 182.66 239.71 181.61",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.41,235.12l-21.54-12.43-9.43-5.45c-1.2,2.94,1.71,5,5.39,9.21,3.89,4.45,7.32,9.8,10.86,13.1a19.15,19.15,0,0,0,6.11,4.16V250l4.3,2.49,6.29-4.73C232.58,242.42,231.41,235.12,231.41,235.12Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "224.29 169.71 219.99 167.22 219.99 218.17 224.29 218.28 224.29 169.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.08,182.57l3.34-2.46c-.08-.22-.14-.44-.23-.65l1.22-.08-2.68-.12-4.47-2.47a10.61,10.61,0,0,0-1.51.75l1.4.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.25,181.84l3.13-2.38-4.32-2.62a19,19,0,0,0-2.91,2.3l3,1.74Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.71 181.61 235.43 179.11 235.45 179.07 235.45 184.48 240.43 182.66 239.71 181.61"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M227.1,252.53V246.2A19.19,19.19,0,0,1,221,242c-3.54-3.3-7-8.66-10.86-13.1s-7-6.53-5.12-9.78a12.08,12.08,0,0,1,7.26-5c3.74-.67,8,1.16,12,4.13V169.71a12.32,12.32,0,0,1,5.57-9.66h0c3.08-1.78,5.58-.34,5.58,3.22v21.21s7.69-6.82,10.79-2.64c0,0,7.56-7.91,11-1.23,0,0,5.54-4.47,8,.72s1.3,16.17,0,22.95-5.37,23-5.37,23v6.33Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.45,193.59s.7-9.68,4.26-12l-.13,0a23.6,23.6,0,0,0-4.13,2.83v-.18a.21.21,0,0,0,0,.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25,181.84v8.86s1-9.11,3-11.31A17.66,17.66,0,0,0,246.25,181.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.21,180.61h0v8.89s.54-8.95,2.47-10.27A9.71,9.71,0,0,0,257.21,180.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.54,151.44h0c-.7.4-1.26.17-1.26-.53v-7a2.6,2.6,0,0,1,1.26-2h0c.69-.4,1.25-.16,1.25.53v7A2.59,2.59,0,0,1,225.54,151.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,162.53h0c-.49.84-1.28,1.3-1.77,1l-4.07-2.35c-.49-.28-.49-1.2,0-2h0c.49-.85,1.28-1.31,1.77-1l4.07,2.35C215.53,160.76,215.53,161.68,215,162.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69,177.06v.2a2.78,2.78,0,0,1-1.35,2.12l-5.56,3.21c-.74.43-1.35.18-1.35-.57v-.2a2.81,2.81,0,0,1,1.35-2.12l5.56-3.21C210.09,176.06,210.69,176.31,210.69,177.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.38,160.12v-.2a2.78,2.78,0,0,1,1.35-2.13l5.56-3.21c.74-.43,1.35-.17,1.35.57v.2a2.81,2.81,0,0,1-1.35,2.12l-5.56,3.21C241,161.11,240.38,160.86,240.38,160.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,150.4h0c-.49-.28-.49-1.19,0-2l4.07-7c.49-.85,1.28-1.31,1.77-1h0c.49.29.49,1.2,0,2.05l-4.07,7C237.32,150.23,236.52,150.69,236,150.4Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.22,315.22v-1.14c-.45,1.33-2.53,7.08-5.68,10-2.51,2.29-5.94,4.93-6.81,7.48s4.77,3.55,7.11,3.14c2.73-.49,6.25-2,8.17-4.39,1.35-1.66,2.21-3.62,3.17-4.93s3.18-2.75,3.71-4.26c.28-.83-.06-2.65-.46-4.18s-.77-2.95-1.25-2.82V315a6.32,6.32,0,0,1-4,1.34C397,316.34,394.21,316.1,394.22,315.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.26,326.05c.78-.69,1.57-1.37,2.28-2,2.2-2,3.88-5.42,4.85-7.75a11,11,0,0,0,.83-4.19v-4.53h8v7.38h0v.2l0,0c-.38,1.65-4,6-6.11,8.92-1.39,1.92-4,4.36-7.19,4.79C385.85,329.27,384.32,328.32,386.26,326.05Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.19,307.37v-1.14c-.45,1.34-2.54,7.09-5.69,10-2.51,2.29-5.94,4.94-6.81,7.49s4.77,3.55,7.11,3.13c2.73-.48,6.25-2,8.17-4.38,1.35-1.66,2.21-3.63,3.17-4.93s3.19-2.76,3.71-4.27c.28-.83-.06-2.64-.46-4.17s-.77-3-1.25-2.83v.87a6.29,6.29,0,0,1-4,1.35C366,308.49,363.18,308.26,363.19,307.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.23,318.21c.77-.7,1.56-1.37,2.27-2,2.2-2,3.88-5.43,4.85-7.76a10.91,10.91,0,0,0,.84-4.18v-4.54h7.95v7.38h0v.2l0,0c-.38,1.66-4,6.05-6.11,8.92-1.39,1.92-4,4.37-7.19,4.79C354.81,321.42,353.28,320.48,355.23,318.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,191.55c6.17,13.47-.23,60.94-.23,60.94.19,2.18,2.69,6.49,3.62,16.11,1.1,11.37-1.73,39.92-1.73,39.92a8.6,8.6,0,0,1-8,.32s-7.58-43-9-54.3C384,244.67,381.58,223,381.58,223l-6.79,31.5a59,59,0,0,1,2.15,9.74c.65,6.65-5.8,37.61-5.8,37.61s-2.74,1-7.95.24c0,0-2.28-41.09-2.88-49.1-1-13.45,2.56-55.43,5-63.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.58,223l-2-12.52s-8.48-1.75-12.32-5.37a21.88,21.88,0,0,0,10,6.66l2.25,9.64-3.93,29.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.55,144.37a11.43,11.43,0,0,0-10.13,4.54c-3.18,4.16-15.37,20-15.37,20s-18-9-18.85-10.06-.38-3.22-.14-4.4.65-3.83.91-4.57c.46-1.29-1.45-.94-2.58.27s-1.62,3.57-2.19,4-4.83-4.51-6.91-6.88-3-4-4.43-3.05c-1,.7-.36,2.11,1.13,4.14a27.44,27.44,0,0,1,1.92,2.7c.17.36-.37.65-.59.85-.4.36-1.12,1-1.17,1.51a4.69,4.69,0,0,1-.06.92c-.19.68-1,1-1.26,1.66-.17.47,0,1-.08,1.51-.06.32-.24.61-.3.94a2.23,2.23,0,0,0,.67,1.74c1.45,1.74,3.44,2.4,5.35,3.46,1.59.88,3.23,1.26,5.06,2.07s23.05,15.53,26.41,13.67,20.7-22,20.7-22C379.64,149.08,376.55,144.37,376.55,144.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.72,144.74h0c7.9.55,8.46,4.37,10.44,8.54a13.54,13.54,0,0,1,.37,10.2L395,179.42s2.58,6.24,5.58,12.13c-13.83,7.72-31.1,3.66-35.26-2-.18-1.2.89-10.54,1.55-16.64-2.44-6.11-3.08-10-2.05-14,1.91-7.5,9.31-14.8,12.59-14.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.11,138.19h3.07A16.17,16.17,0,0,0,401.35,122h0a16.26,16.26,0,0,0-16.26-16.25H382.2A16.25,16.25,0,0,0,366,122h0A16.16,16.16,0,0,0,382.11,138.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,146.71h0a9.56,9.56,0,0,1-9.55-9.55V116.7h0a9.55,9.55,0,0,1,9.55,9.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.2,113.08l-2.39,3.84a2.2,2.2,0,0,0,3.12-.63A2.39,2.39,0,0,0,402.2,113.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76,112.93c-1.87,1.1-4.18,5.8-3.95,15.66.19,8.36,2.9,10.42,4.26,11s4,.23,6.53-.2v5s-3.52,4.09-3.3,6.39,5.09,2.84,8.39.6a21.51,21.51,0,0,0,5.41-5.67V133.63a3.19,3.19,0,0,0,4.53.43c2.82-1.87,2.93-6.5,1.29-8.16s-5.17-1.13-5.82,1.16c0,0-4.07.15-9.48-2.82A15.22,15.22,0,0,1,371.76,112.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,126.49a1.05,1.05,0,1,0,1.11-1A1.09,1.09,0,0,0,378.07,126.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.86,133.58l-2.44.77a1.26,1.26,0,0,0,1.58.88A1.34,1.34,0,0,0,376.86,133.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.46,123.27l2.12-1.48a1.24,1.24,0,0,0-1.76-.36A1.36,1.36,0,0,0,369.46,123.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,125.73a1.06,1.06,0,0,0,1,1.14,1.09,1.09,0,1,0-1-1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.08 125.13 374.91 131.46 371.58 130.43 375.08 125.13",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,139.41c2.69-.35,8.22-1.94,9.08-4.12a5.7,5.7,0,0,1-1.94,2.79c-1.65,1.41-7.14,3-7.14,3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.18,193.05a8.35,8.35,0,0,0,6.22-10.19,3,3,0,0,0-2.94-2.29h0a8.08,8.08,0,0,0,3.46-5.15l1.68-10a11.54,11.54,0,0,0-.43-4.85l5.56-6.43,1,.71a13.82,13.82,0,0,1-.23,8.62L395,179.42s2.58,6.24,5.58,12.13a35.75,35.75,0,0,1-29.55,2A40.45,40.45,0,0,0,386.18,193.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,184.43c-7.18-29.35-12.49-39.14-21.21-39-2.55,3-1.84,12.24,2.18,17.82,0,0,9,18.93,10.41,25.66,1.25,5.91,2.68,13.35,2.59,18.43a3.71,3.71,0,0,1-1,2.42c-1.64,1.78-1.64,3.21-2.71,5.17-.83,1.54-1.74,2.12-1.48,2.46a2,2,0,0,0,2.7.2,10.25,10.25,0,0,0,2-2,20.39,20.39,0,0,1-1.62,5.45c-1.84,4.15-1.39,6.27,4.21,4.79,3.51-.93,5.72-3.85,6.25-12.3a65.1,65.1,0,0,0,.09-9.34C416.45,196.19,415.91,189.15,414.75,184.43Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.51,268.34c.77-28.57-1.52-35.41-9.12-40.64l-2.95,16.55s3.46,19.5,3.09,26c-.32,5.71-.88,12.85-2.23,17.46a3.48,3.48,0,0,1-1.51,2c-1.94,1.21-2.72,2.45-4.18,4-1.14,1.2-2.11,1.49-2,1.87a1.89,1.89,0,0,0,2.41.86,13.61,13.61,0,0,0,2.74-1.49,17.4,17.4,0,0,1-2.81,4.83c-2.72,3.33-2.84,5.38,2.65,5.43,3.43,0,6.17-2.09,8.76-9.66a62.16,62.16,0,0,0,2.41-8.51C342.13,279.49,343.39,272.94,343.51,268.34Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,225.53c3.63-.53,8.56.23,11.75,5.93s4,15.51,4.33,25.26c0,0-6.33,5.29-13.93,2.69Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,225.53c3.63-.53,8.56.23,11.75,5.93s4,15.51,4.33,25.26c0,0-6.33,5.29-13.93,2.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,382.64c.57.22.72,1.32.81,3.5.06,1.65.42,4.54-1.52,5.11s-4.77.28-6-1.27c-1.55-2-2.59-3.66-4.8-6-1.92-2.06-4-4-4.76-6.86-.7-2.61-.12-3.74,1.66-4.5,2.44-1,6.29,2.37,8.2,2.9C333.9,376,338.09,382.42,338.67,382.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,380.62v2.68a6.57,6.57,0,0,1-6.78.18c-.11-.26-.7-3.83-.7-3.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,398.09a44.32,44.32,0,0,1,1.18,4.37c.33,1.62.8,4.33.24,5.55s-2.78,2-6.22,2c-2.22,0-5.68,1.49-8.05,2.81s-7.55,1.91-10.14,1.61c-3.05-.36-6.21-2.13-6.71-3.4s.16-2.57,7.36-5.64c.07,0,10-3.26,13.48-7.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,395.19s0,2,0,3.13-1.33,2.83-4.81,2.7c-2.44-.08-4.14-.74-4-2.75v-2.9Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.41,345.05a73.36,73.36,0,0,0-3.16-14s.95-12,1.41-23.46c.5-12.34,0-27.84.21-30.92,0,0-39.8-8-40.51,6.2s1.57,50.56,2,56.82,1.55,11.81,2.85,22,4.85,33.68,4.85,33.68a9.4,9.4,0,0,0,8.86-.18s2.8-28.51,2.51-35.74a61.8,61.8,0,0,0-2.74-15.77s.75-11.76,1.42-22,1.37-15.14,1.52-19.58l.86-.43s.87,17.64,1.34,23.91,1.47,12.27,3.28,23.9c1.58,10.1,6.26,31.45,6.26,31.45,4.54,2.46,7.26-.32,7.26-.32S341.64,353.81,340.41,345.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,302.11s9.66-4.76,14.49-9.05c0,0-4.49,6.32-10.38,9.12,0,0-2.09,21.92-2.08,21.48l-1.21-21.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.08 221.01 313.44 233.97 325.14 233.12 322.69 218.42 311.08 221.01",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51,232.17c-1.16-3.52-5.63-7.36-10.1-6.53a132.64,132.64,0,0,0-19.6,4.89c-4.1,1.47-7.83,5-8.17,18.48,0,0-1.37,31.42-1.39,37.49,10.28,4.07,21,3.95,26.89,2.66,12.32-2.69,13.8-7.8,13.8-7.8s.16-22.59-.21-32.35C338.42,240.72,338.31,234.59,337.51,232.17Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.05,205.24s-3,4.74-2.61,5.19,2.63.81,2.63.81Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.29,192.15c-6.19,1.45-7.92,4.22-8.29,14.12-.38,10.34.75,13.56,2.14,14.92.93.92,6,1,8.58.21,3.19-1,10.4-3.7,13.68-9,3.86-6.2,4.73-14.5.37-17.81C320.63,190,312.81,191.55,310.29,192.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,221.72c2.1-1.69,1.91-2.78,1.91-2.78-1.5,1.41-7.08,2.61-9,2.25C304.91,222,308.54,222.12,311.21,221.72Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.07,194.72c1.82,3.11,5.76,4.6,5.76,4.6,1.19,1.35.53,6.63,2.62,7.46,0,0,.9-3.84,4.13-3.43s3.78,4.53,1.79,7.08-3.9,1.64-3.9,1.64.22,5.45,2.71,8.49c0,0,2.77.83,7.8-.37,3.1-.73,7.41-4.72,9.16-8.87,3.72-8.8,3.81-16.64-1.8-18.86-.69-4-3.89-5.73-7.51-6.48-7.79-1.6-12.81,3.26-18.81,2.84C300.58,188.58,299.94,191.07,302.07,194.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.47,193.8l3.67-2.28a2.16,2.16,0,1,0-3.67,2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.13,230.48s-5.82,1.08-8.86,5.68-16.2,21.1-16.2,21.1-18.92-9.47-19.85-10.6-.41-3.39-.15-4.64.68-4,1-4.8c.48-1.37-1.53-1-2.72.27s-1.71,3.76-2.3,4.19-5.1-4.75-7.28-7.25-3.21-4.25-4.68-3.22c-1.05.75-.37,2.23,1.19,4.37a24.15,24.15,0,0,1,2,2.84c.19.38-.39.69-.61.89-.43.38-1.18,1-1.24,1.6a5.26,5.26,0,0,1,0,1c-.21.71-1.09,1-1.34,1.74-.18.51,0,1.07-.08,1.6-.07.34-.25.64-.32,1a2.39,2.39,0,0,0,.71,1.84c1.53,1.83,3.63,2.53,5.64,3.64,1.67.93,3.4,1.33,5.33,2.19s24.61,17.62,28.15,15.67,21.68-23.15,21.68-23.15A14.65,14.65,0,0,0,308.13,230.48Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,229.8c-2.5.28-6-.18-10.91,5.08a153.17,153.17,0,0,0-11,14.2,13.91,13.91,0,0,0,11,10.33s8.58-8.79,11-13.64S313.1,233.06,310.16,229.8Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,229.8c-2.5.28-6-.18-10.91,5.08a153.17,153.17,0,0,0-11,14.2,13.91,13.91,0,0,0,11,10.33s8.58-8.79,11-13.64S313.1,233.06,310.16,229.8Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIllustration);
export default __webpack_public_path__ + "static/media/select__illustration.3ac3b8d7bca2bf05b43c8788775dcb2b.svg";
export { ForwardRef as ReactComponent };